import { InputWithPrefix } from "components/ui/input-with-prefix";
import { SecondaryButton } from "components/ui/secondary-button";
import React from "react";

interface Props {
    communityName: string | null;
    rateLabel: string;
    residentCharges: string;
    onResidentChargesChange: (value: string) => void;
    onApply: () => void;
    applied: boolean;
    hint: string | null;
}

export const ContractPrefillBanner: React.FC<Props> = props => {
    const {
        communityName,
        rateLabel,
        residentCharges,
        onResidentChargesChange,
        onApply,
        applied,
        hint,
    } = props;
    return (
        <div className="rounded-md border border-brand-200 bg-brand-50 p-4 space-y-3">
            <div>
                <div className="font-semibold">
                    {applied ? "Contract terms applied" : "Apply contract terms"}
                </div>
                <div className="text-sm text-gray-600">
                    {communityName ? `${communityName} — ${rateLabel}` : rateLabel}
                </div>
            </div>
            <div className="flex items-end gap-2">
                <InputWithPrefix
                    label="Total resident charges"
                    prefix="$"
                    type="number"
                    min="0"
                    value={residentCharges}
                    onChange={e => onResidentChargesChange(e.target.value)}
                />
                <SecondaryButton
                    onClick={e => {
                        e.preventDefault();
                        onApply();
                    }}>
                    Apply
                </SecondaryButton>
            </div>
            {hint ? (
                <div
                    className={
                        applied ? "text-sm text-green-800" : "text-sm text-gray-600"
                    }>
                    {hint}
                </div>
            ) : null}
        </div>
    );
};
